<template>
  <div>
    <base-modal name="uploadExcel">
      <template #body>
        <div class="p-10">
          <h6 class="font-semibold text-18 text-title">{{$t('upload_excel')}}</h6>
          <h6 class="text-sm text-title mb-6">{{$t('upload_excel_users')}}</h6>
          <input
            type="file"
            ref="excelInput"
            @change="uploadExcelHandler"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import axiosConfig from '@/services/axios.config';
import serverErrorsHandler from '@/utils/serverErrorsHandler';

import BaseModal from './BaseModal.vue';

export default {
  name: 'UploadExcelModal',
  props: {
    companyId: {
      type: Number,
      default: null,
    },
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      excelFile: '',
    };
  },
  methods: {
    uploadExcelHandler() {
      const input = this.$refs.excelInput;
      const file = input.files;
      if (file && file[0]) {
        this.$emit('fileUrl', file[0]);
        this.excelFile = file[0];
      }
      const formData = new FormData();
      formData.append('excel', this.excelFile);
      axiosConfig
        .post(`/admin/companies/${this.companyId}/excel-import`, formData)
        .then((response) => {
          this.$toast.success(response.data.success);
        })
        .catch((error) => {
          serverErrorsHandler(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
